import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, XIcon, ZoomInIcon } from 'lucide-react';
interface ProductGalleryProps {
  images: string[];
  productName: string;
}
export function ProductGallery({
  images,
  productName
}: ProductGalleryProps) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);
  const handlePrevious = () => {
    setSelectedIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  const handleNext = () => {
    setSelectedIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
  };
  return <>
      <div className="space-y-4" data-id="element-287">
        {/* Main Image */}
        <div className="relative aspect-square bg-slate-100 rounded-2xl overflow-hidden group" data-id="element-288">
          <motion.img key={selectedIndex} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.3
        }} src={images[selectedIndex]} alt={`${productName} - зображення ${selectedIndex + 1}`} className="w-full h-full object-cover cursor-zoom-in" onClick={() => setIsZoomed(true)} data-id="element-289" />

          {/* Zoom Button */}
          <button onClick={() => setIsZoomed(true)} className="absolute bottom-4 right-4 p-2 bg-white/90 rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity" aria-label="Збільшити зображення" data-id="element-290">
            <ZoomInIcon className="w-5 h-5 text-slate-700" data-id="element-291" />
          </button>

          {/* Navigation Arrows */}
          {images.length > 1 && <>
              <button onClick={handlePrevious} className="absolute left-4 top-1/2 -translate-y-1/2 p-2 bg-white/90 rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity hover:bg-white" aria-label="Попереднє зображення" data-id="element-292">
                <ChevronLeftIcon className="w-5 h-5 text-slate-700" data-id="element-293" />
              </button>
              <button onClick={handleNext} className="absolute right-4 top-1/2 -translate-y-1/2 p-2 bg-white/90 rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity hover:bg-white" aria-label="Наступне зображення" data-id="element-294">
                <ChevronRightIcon className="w-5 h-5 text-slate-700" data-id="element-295" />
              </button>
            </>}
        </div>

        {/* Thumbnails */}
        {images.length > 1 && <div className="flex gap-3 overflow-x-auto pb-2" data-id="element-296">
            {images.map((image, index) => <button key={index} onClick={() => setSelectedIndex(index)} className={`
                  flex-shrink-0 w-20 h-20 rounded-xl overflow-hidden border-2 transition-all
                  ${selectedIndex === index ? 'border-sky-500 ring-2 ring-sky-200' : 'border-transparent hover:border-slate-300'}
                `} aria-label={`Показати зображення ${index + 1}`} aria-current={selectedIndex === index} data-id="element-297">
                <img src={image} alt={`${productName} - мініатюра ${index + 1}`} className="w-full h-full object-cover" data-id="element-298" />
              </button>)}
          </div>}
      </div>

      {/* Lightbox */}
      <AnimatePresence data-id="element-299">
        {isZoomed && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center" onClick={() => setIsZoomed(false)} data-id="element-300">
            <button onClick={() => setIsZoomed(false)} className="absolute top-4 right-4 p-2 text-white hover:bg-white/10 rounded-full transition-colors" aria-label="Закрити" data-id="element-301">
              <XIcon className="w-8 h-8" data-id="element-302" />
            </button>

            {images.length > 1 && <>
                <button onClick={e => {
            e.stopPropagation();
            handlePrevious();
          }} className="absolute left-4 p-3 text-white hover:bg-white/10 rounded-full transition-colors" aria-label="Попереднє зображення" data-id="element-303">
                  <ChevronLeftIcon className="w-8 h-8" data-id="element-304" />
                </button>
                <button onClick={e => {
            e.stopPropagation();
            handleNext();
          }} className="absolute right-4 p-3 text-white hover:bg-white/10 rounded-full transition-colors" aria-label="Наступне зображення" data-id="element-305">
                  <ChevronRightIcon className="w-8 h-8" data-id="element-306" />
                </button>
              </>}

            <motion.img key={selectedIndex} initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} src={images[selectedIndex]} alt={productName} className="max-w-[90vw] max-h-[90vh] object-contain" onClick={e => e.stopPropagation()} data-id="element-307" />

            {/* Dots indicator */}
            {images.length > 1 && <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-308">
                {images.map((_, index) => <button key={index} onClick={e => {
            e.stopPropagation();
            setSelectedIndex(index);
          }} className={`w-2 h-2 rounded-full transition-all ${selectedIndex === index ? 'bg-white w-6' : 'bg-white/50'}`} aria-label={`Зображення ${index + 1}`} data-id="element-309" />)}
              </div>}
          </motion.div>}
      </AnimatePresence>
    </>;
}